import React from 'react';

const CompanyPyn = ({ pyn, onClick }) => {
  return (
    <a href="#address" onClick={onClick} data-latitude={pyn.pyn.latitude} data-longitude={pyn.pyn.longitude} className="collection-item">
      {pyn.address}
      {/* <span className="badge">
        {pyn.pyn.latitude},{pyn.pyn.longitude}
      </span> */}
    </a>
  );
};

export default CompanyPyn;
